import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AppleSourceID,
  BingSourceID,
  FacebookSourceID,
  GoogleSourceID,
  InstagramSourceID,
  XSourceID,
} from '../../../local-seo';

@Component({
  selector: 'local-seo-sync-info-modal',
  templateUrl: './sync-info-modal.component.html',
  styleUrls: ['./sync-info-modal.component.scss'],
  standalone: false,
})
export class SyncInfoModalComponent {
  readonly Google = GoogleSourceID;
  readonly Facebook = FacebookSourceID;
  readonly Instagram = InstagramSourceID;
  readonly X = XSourceID;
  readonly Bing = BingSourceID;
  readonly Apple = AppleSourceID;
  source: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SyncInfoModalComponent>,
  ) {
    this.source = data.source;
  }
  onCancel(): void {
    this.dialogRef.close();
  }
}
